export default __webpack_public_path__ + "static/media/fat_check.a2936411.svg";